module.exports = __webpack_public_path__ + "static/media/run_7.48d00d01.png";